export default "__VITE_ASSET__gy5donsJ__"